import { useEffect, useState } from "react"
import { TextField, Button, Grid, Box, Typography, InputAdornment } from "@mui/material"
import Layout from "../../../../components/appbar_mobile"
import HistorySalesTable from "../../../../components/table/history-farmer-table"
import { updateBatch } from "../../../../services/orders"

import { getHistorySalesOrders, getBatchOrders, getBatchByOrderId, getOrdersById } from "../../../../services/orders"
import { useNavigate, useParams } from "react-router-dom"
import moment from "moment"

const HistoryPage = () => {
    const [check_round_1, setCheckround1] = useState(false)
    const [check_round_2, setCheckround2] = useState(true)

    const [formData, setFormData] = useState({
        lot_no: '',
        sku: '',
        weight: '',
        farmer_name: '',
        farmer_id: '',
        agent: '',
        receive_date: '',
        moisture_1: '',
        moisture_2: '',
        mitragynine_1: '',
        mitragynine_2: ''
    })

    const role_id = localStorage.getItem('role_id')
    const token = localStorage.getItem('accessToken')
    const navigate = useNavigate()
    const { batch_id } = useParams()
    const [batch, order] = batch_id.split("_")
    const [batchId, setBatchID] = useState(batch)
    const [orderId, setOrderID] = useState(order)
    localStorage.setItem('redirectAfterLogin', window.location.pathname)
    useEffect(() => {
        fetchHistoryData()
        if (!token) {
            navigate('/login_mobile')
        }
    }, [])

    const fetchHistoryData = async () => {
        try {
            let res = await getOrdersById(Number(orderId), token)

            let res_batch = await getBatchOrders({ order_id: Number(orderId), role_id: 1}, token)
            if (res_batch.status === 200) {
                const filtered = res_batch.data.data.filter((item) => item.batch_id === Number(batchId));
                const list = filtered.map(item => ({
                    agent: res.data.data.vendor.firstname + ' ' + res.data.data.vendor.lastname,
                    receive_date: res.data.data.delivery_date
                        ? moment(res.data.data.delivery_date).format('YYYY-MM-DD')
                        : '',
                    lot_no: res.data.data.lot_no,
                    farmer_id: item.agents[0].tag_user_id,
                    weight: Number(item.quantity).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }),
                    sku: item.product,
                    farmer_name: item.agents[0].owner,
                    mitragynine_1: item.mitragynine_1,
                    mitragynine_2: item.mitragynine_2,
                    moisture_1: item.moisture_1,
                    moisture_2: item.moisture_2,
                }))
                if (list[0].mitragynine_1 && list[0].moisture_1) {
                    setCheckround1(true)
                    setCheckround2(false)

                }
                if (list[0].mitragynine_2 && list[0].moisture_2) {
                    setCheckround2(true)
                }
                setFormData(list[0])

            } else {
                navigate('/login_mobile')
            }

        } catch (error) {
            console.log(error)
            // navigate('/login_mobile')
        }
    }

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const handleSubmit = async () => {
        try {
            let payload = {
                id:Number(batchId) ,
                mitragynine_1: formData.mitragynine_1,
                mitragynine_2: formData.mitragynine_2,
                moisture_1: formData.moisture_1,
                moisture_2: formData.moisture_2,
            }
            await updateBatch(payload, token)
            alert("บันทึกสำเร็จ")
            fetchHistoryData()

        } catch (error) {

        console.log(error)
            alert("บันทึกไม่สำเร็จ")
        }
    }

    return (
        <Layout title={'บันทึกค่าสาร'}>
            <Box sx={{ p: 2 }}>
                <Typography variant="h6" gutterBottom>
                    กรอกข้อมูล
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Lot No."
                            name="lot_no"
                            value={formData.lot_no ?? ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="SKU"
                            name="sku"
                            value={formData.sku ?? ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="ชื่อเกษตรกร"
                            name="farmer_name"
                            value={formData.farmer_name ?? ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="ID Farmer"
                            name="farmer_id"
                            value={formData.farmer_id ?? ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="น้ำหนักรวม"
                            name="weight"
                            value={formData.weight ?? ""}
                            onChange={handleChange}
                            disabled={true}

                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="หัวจุด"
                            name="agent"
                            value={formData.agent ?? ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="วันและเวลาที่รับเข้าสินค้า"
                            name="receive_date"
                            value={formData.receive_date ?? ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="ค่าความชื้นครั้งที่ 1"
                            name="moisture_1"
                            value={formData.moisture_1 ?? ""}
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                            disabled={check_round_1}

                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="ค่าสาร Mitragynine ครั้งที่ 1"
                            name="mitragynine_1"
                            value={formData.mitragynine_1 ?? ""}
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                            disabled={check_round_1}

                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="ค่าความชื้นครั้งที่ 2"
                            name="moisture_2"
                            value={formData.moisture_2 ?? ""}
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                            disabled={check_round_2}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="ค่าสาร Mitragynine ครั้งที่ 2"
                            name="mitragynine_2"
                            value={formData.mitragynine_2 ?? ""}
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                            disabled={check_round_2}

                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button fullWidth variant="contained" color="primary" onClick={handleSubmit} disabled={(check_round_1 && check_round_2)}>
                            บันทึกข้อมูล
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Layout>

    )
}

export default HistoryPage
